const reduceObject =
	obj =>
	(...args) =>
		Object.entries(obj).reduce(...args)

const generateCSSEasingVariables = ({ theme: { easing } }) => `
  :root {
    ${reduceObject(easing)((acc, [k, v]) => `${acc}\n\t--ease-${k}: ${v};`, '')}
  }
`

export default generateCSSEasingVariables
